import { combineReducers } from "redux";
import { AlertReducer } from "./AlertReducer";
import { AuthReducer } from "./AuthReducer";
import { BusinessReducer } from "./BusinessReducer";
import { ProductReducer } from "./ProductReduces";
import { RebrandReducer } from "./RebrandReducer";
import { SupportReducer } from "./SupportReducer";
import { ClientReducer } from "./ClientReducer";

const appReducer = combineReducers({
    alert: AlertReducer,
    auth: AuthReducer,
    support: SupportReducer,
    rebrand: RebrandReducer,
    business: BusinessReducer,
    client: ClientReducer,
    product: ProductReducer
})

const rootReducers = (state, action) => {
    if (action.type === 'LOGOUT') {
        localStorage.clear();
        state = undefined
    }
    return appReducer(state, action)
}

export default rootReducers;